"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderReactComponentsInsideElementsIfNeeded = exports.getTranslationResources = void 0;
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
const hypernova_renderer_1 = require("@as-react/hypernova-renderer");
const searchAndHydrateComponents = (availableComponents, element, storeConfigurator, numeralInstance, i18nTranslationResources, dynamicStore) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const availableComponentKeys = Object.keys(availableComponents);
    const reactComponentKeysInsideElement = availableComponentKeys.filter(availableComponentKey => element.querySelectorAll(`div[data-hypernova-key="${String(availableComponentKey)}"]`).length > 0);
    for (const reactComponentKeyInsideElement of reactComponentKeysInsideElement) {
        yield (0, hypernova_renderer_1.renderReactReduxAndTranslation)(availableComponents[reactComponentKeyInsideElement], storeConfigurator, numeralInstance, i18nTranslationResources, dynamicStore);
    }
});
const getTranslationResources = (i18nextOptions, language) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const dictionariesRequests = i18nextOptions.ns
            .map(dictionary => {
            const loadPath = i18nextOptions.backend.loadPath;
            const queryStringParams = i18nextOptions.backend.queryStringParams;
            const urlQueryStringParam = Object.keys(queryStringParams)
                .map(key => `${key}=${queryStringParams[key]}`)
                .join('&');
            const urlBase = loadPath.replace('{ns}', dictionary).replace('{lng}', language);
            return {
                requestUrl: `${urlBase}?${urlQueryStringParam}`,
                dictionary: dictionary,
            };
        })
            .map((props) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { requestUrl, dictionary } = props;
            const response = yield fetch(requestUrl);
            const data = yield response.json();
            return { [`${dictionary}`]: data };
        }));
        const dictionariesResults = yield Promise.all(dictionariesRequests);
        return {
            [`${language}`]: Object.assign({}, ...dictionariesResults),
        };
    }
    catch (e) {
        console.error('[getTranslationResources] Error', e);
        return {};
    }
});
exports.getTranslationResources = getTranslationResources;
const renderReactComponentsInsideElementsIfNeeded = (availableComponents, element, renderingTools, i18nInstance, locale, translationLanguage, aemVersion) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (typeof window !== 'undefined' && 'performance' in window) {
        performance === null || performance === void 0 ? void 0 : performance.mark('as-react-hydrate-pre-start');
    }
    if (element.querySelectorAll('div[data-hypernova-key]').length > 0) {
        const storeConfiguratorPromise = yield renderingTools.redux.configureStore();
        const storeConfigurator = yield storeConfiguratorPromise.default();
        const asNumeralPromise = yield renderingTools.numeral();
        const dynamicStore = new common_utils_1.DynamicStore();
        if (i18nInstance === undefined) {
            const i18nFrontendInitOptionsPromise = yield renderingTools.i18n.frontEndInitOptions();
            const i18nFrontEndConfiguration = i18nFrontendInitOptionsPromise.default(aemVersion, translationLanguage);
            const translationResources = yield (0, exports.getTranslationResources)(i18nFrontEndConfiguration, translationLanguage);
            if (!(0, common_utils_1.isNullOrUndefined)(locale)) {
                asNumeralPromise.default.changeLocal(locale);
            }
            const i18nInstancePromise = yield renderingTools.i18n.instanceCreator();
            i18nInstance = i18nInstancePromise.default();
            yield i18nInstance.init(Object.assign(Object.assign({}, i18nFrontEndConfiguration), {
                lng: translationLanguage,
                resources: translationResources,
            }));
            i18nInstance.services.pluralResolver.addRule('nl_nl', i18nInstance.services.pluralResolver.getRule('nl'));
        }
        if (typeof window !== 'undefined' && 'performance' in window) {
            performance === null || performance === void 0 ? void 0 : performance.mark('as-react-hydrate-start');
        }
        yield searchAndHydrateComponents(availableComponents, element, storeConfigurator, asNumeralPromise.default, {
            language: translationLanguage,
            translationResources: i18nInstance.services.resourceStore.data,
        }, dynamicStore);
        if (typeof window !== 'undefined' && 'performance' in window) {
            performance === null || performance === void 0 ? void 0 : performance.mark('as-react-hydrate-end');
            performance === null || performance === void 0 ? void 0 : performance.measure('as-react-hydrate', 'as-react-hydrate-start', 'as-react-hydrate-end');
        }
    }
    (0, common_utils_1.setReadyState)();
});
exports.renderReactComponentsInsideElementsIfNeeded = renderReactComponentsInsideElementsIfNeeded;
//# sourceMappingURL=client-side-hydrater.js.map